"use client"
import { atom, useAtom } from "jotai"
import { useHydrateAtoms } from "jotai/utils"

const breadcrumbAtom = atom<undefined | string>()

import { ScopeProvider } from "jotai-scope"

/**
 * Helper Jotai atoms to manage the breaddcrumb state.
 */
export function useBreadcrumbContext() {
  /**
   * The breadcrumbs for the current route.
   */
  const [breadcrumb, setBreadcrumb] = useAtom(breadcrumbAtom)
  const data = {
    breadcrumb,
    setBreadcrumb,
  }

  return data
}

function HydratePostEdits({
  children,
  breadcrumb,
}: {
  children: React.ReactNode
  breadcrumb?: string
}) {
  useHydrateAtoms([[breadcrumbAtom, breadcrumb]])

  return <> {children} </>
}

export function BreadcrumbContextProvider({
  children,
  breadcrumb,
}: {
  children: React.ReactNode
  breadcrumb?: string
}) {
  return (
    <ScopeProvider atoms={[breadcrumbAtom]}>
      <HydratePostEdits breadcrumb={breadcrumb}>{children}</HydratePostEdits>
    </ScopeProvider>
  )
}
